enum ArmorSubclass {
  Rings = -2,
  Trinkets = -4,
  OffHand = -5,
  Miscellaneous = 0,
  Cloth = 1,
  Leather = 2,
  Mail = 3,
  Plate = 4,
  Shield = 6,
  Libram = 7,
  Idol = 8,
  Totem = 9
}

export default ArmorSubclass
